// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"e907061d","581":"2bfe0b7f"}[chunkId] + ".chunk.js";
};